import {
  collection,
  query,
  where,
  getDocs,
  writeBatch,
  doc,
  limit,
  Timestamp,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../firebase";
import { statsService } from "./statisticsService";

// DISABLED: Function to clean up expired games
export const cleanupExpiredGames = async () => {
  try {
    console.log("Cleanup disabled - skipping expired games cleanup");
    return 0;
  } catch (error) {
    console.error("Error in cleanup:", error);
    return 0;
  }
};

// DISABLED: Function to clean up single player games
export const cleanupSinglePlayerGames = async () => {
  try {
    console.log("Cleanup disabled - skipping single player cleanup");
    return 0;
  } catch (error) {
    console.error("Error in cleanup:", error);
    return 0;
  }
};

// DISABLED: Function to run both cleanup operations
export const runAllCleanupTasks = async () => {
  try {
    console.log("All cleanup tasks disabled");
    return { expiredCount: 0, singlePlayerCount: 0 };
  } catch (error) {
    console.error("Error running cleanup tasks:", error);
    return { expiredCount: 0, singlePlayerCount: 0 };
  }
};

// Keep the optimized listener function (this is not causing issues)
export const getOptimizedRoomListener = (roomId, callback) => {
  if (!roomId) return () => {};

  // Query by exact roomId instead of collection scan
  const q = query(
    collection(db, "rooms"),
    where("roomId", "==", roomId),
    limit(1) // There should only be one room with this ID
  );

  return getDocs(q)
    .then((querySnapshot) => {
      if (!querySnapshot.empty) {
        const roomDoc = querySnapshot.docs[0];
        // Use document reference for more efficient listening
        return onSnapshot(doc(db, "rooms", roomDoc.id), (docSnapshot) => {
          if (docSnapshot.exists()) {
            callback({ id: docSnapshot.id, ...docSnapshot.data() });
          } else {
            callback(null);
          }
        });
      } else {
        callback(null);
        return () => {};
      }
    })
    .catch((error) => {
      console.error("Error setting up room listener:", error);
      return () => {};
    });
};